const wowApp = require('angular').module('oly.common');

wowApp.directive('olyDisablePanel', [require('./disablepanel.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/disablepanel/index.js